import { RefObject } from '@uifabric/utilities'
import { noop } from 'lodash-es'
import { useEffect, useRef, useState } from 'react'

export default function useHover() {
  const [isHovered, setHovered] = useState(false)

  const ref = useRef<HTMLElement>(null)

  const handleMouseOver = () => setHovered(true)
  const handleMouseLeave = () => setHovered(false)

  useEffect(() => {
    const node = ref.current
    if (node) {
      node.addEventListener('mouseover', handleMouseOver)
      node.addEventListener('mouseleave', handleMouseLeave)

      return () => {
        node.removeEventListener('mouseover', handleMouseOver)
        node.removeEventListener('mouseleave', handleMouseLeave)
      }
    }

    return noop
  }, [ref])

  return [ref, isHovered] as [RefObject<HTMLElement>, boolean]
}
